import { Suspense, useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { ThemeProvider } from "@mui/material/styles";

import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

import { Menu } from "./Menu/menu";
import { Footer } from "./Footer/footer";
import { ErrorBoundary } from "../../Common/ErrorBoundary/errorBoundary";
import { getUser } from "../../../Requests/CommonRequests/commonRequests";
import { redirectToLoginWithReturn } from "../../../Utils/Helpers/Fetch/advancedFetch";
import { SimpleLoader } from "../../Common/Loader/simpleLoader";
import { themeContent } from "../../../Themes/themes";

export function Layout(props) {
    const [isLoaded, setIsLoaded] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        const redirectToLogin = redirectToLoginWithReturn;

        if (Cookies.get('token')) {
            getUser(props)
                .then((res) =>
                    {
                        if (res.payload?.message === 'Unauthenticated.') {
                            redirectToLogin();
                        } else {
                            setIsLoaded(true)
                        }
                    },
                    (error) => console.log(error)
                )
        } else {
            redirectToLogin();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ThemeProvider theme={themeContent}>
            <div className="container" style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <header style={{ flex: '0 0 auto' }}>
                    <Menu {...props} />
                </header>
                <div style={{ flex: '1 0 auto' }}>
                    <CssBaseline />
                    <Container maxWidth="false" sx={{ height: '100%' }}>
                        <ErrorBoundary>
                            <Suspense fallback={<SimpleLoader />}>
                                {isLoaded && <Outlet />}
                            </Suspense>
                        </ErrorBoundary>
                    </Container>
                </div>
                <footer style={{ flex: '0 0 auto' }}>
                    <Footer {...props} />
                </footer>
            </div>
        </ThemeProvider>
    );
}